import { FormlyFieldConfig } from "@ngx-formly/core";
import { BasicModel } from "../basic/basic.model";
import { FormGroup } from "@angular/forms";

export class ProjetSchemaDescrModel extends BasicModel {
    libelle: string = "";
    code: string = "";
    mailModifieurs: string;
    schema: string;
}

export class ProjetAgenceModel extends BasicModel {
    idProjetSchemaDescr: number;
    projetSchemaDescr: ProjetSchemaDescrModel;
    idAgence: number;
    projet: string;
}

export class SchemaForms {
    allProjetSchemaDescr: ProjetSchemaDescrModel[] = [];
    allProjetAgenceForm: FormGroup[] = [];
}

export class ProjetAgenceDemandeModel extends BasicModel {
    idProjetAgence: number;
    projetAgence: ProjetAgenceModel;
    diff: string;
}

export class ProjetAgenceDTO {
    projetAgence: ProjetAgenceModel;
    modifs: string;
}